import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

@Component({
    selector: 'app-asset-properties-dialog',
    templateUrl: './asset-properties-dialog.component.html',
    styleUrls: ['./asset-properties-dialog.component.scss'],
    imports: [MatDialogModule, MatIcon, MatListModule, MatAccordion, MatExpansionModule]
})
export class AssetPropertiesDialogComponent implements OnInit {

    properties: any = {};
    product: any;
    isFolder: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<AssetPropertiesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        console.log(this.data);
        this.product = this.data.product;
        if (this.product && this.product.properties) {
            this.properties = this.product.properties;
            this.isFolder = this.properties.isFolder === 'true' || this.properties.isFolder === true || this.properties.contenttype === 'application/vnd.folder';
            console.log(this.product);
        }
    }

    getAdvancedPropertyKeys(): string[] {
        const commonKeys = ['name', 'createdBy', 'createdDateTime', 'lastModifiedDateTime', 'size', 'contenttype', 'webUrl', 'isFolder', 'dataDescription', 'DataDesc'];
        return Object.keys(this.properties).filter(key => Object.prototype.hasOwnProperty.call(this.properties, key) && !commonKeys.includes(key));
    }

    formatValue(value: any): string {
        if (typeof value === 'object' && value !== null) {
            return JSON.stringify(value, null, 2);
        }
        return String(value);
    }

    formatSize(bytes: number): string {
        if (!bytes || bytes === 0 || isNaN(bytes)) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    getContentTypeIcon(): string {
        const contentType = this.properties.contenttype || this.properties.contentType || '';
        if (this.isFolder) return 'folder';
        
        if (contentType.includes('pdf')) return 'picture_as_pdf';
        if (contentType.includes('image')) return 'image';
        if (contentType.includes('word') || contentType.includes('office')) return 'description';
        if (contentType.includes('excel') || contentType.includes('spreadsheet')) return 'table_view';
        if (contentType.includes('zip') || contentType.includes('archive')) return 'compress';
        if (contentType.includes('json') || contentType.includes('javascript')) return 'code';
        if (contentType.includes('text')) return 'article';
        
        return 'insert_drive_file';
    }

    close(): void {
        this.dialogRef.close();
    }
}
